export const Close = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2716_2719)">
        <path
          d="M18.3 6.20997C17.91 5.81997 17.28 5.81997 16.89 6.20997L12 11.09L7.10997 6.19997C6.71997 5.80997 6.08997 5.80997 5.69997 6.19997C5.30997 6.58997 5.30997 7.21997 5.69997 7.60997L10.59 12.5L5.69997 17.39C5.30997 17.78 5.30997 18.41 5.69997 18.8C6.08997 19.19 6.71997 19.19 7.10997 18.8L12 13.91L16.89 18.8C17.28 19.19 17.91 19.19 18.3 18.8C18.69 18.41 18.69 17.78 18.3 17.39L13.41 12.5L18.3 7.60997C18.68 7.22997 18.68 6.58997 18.3 6.20997Z"
          fill="#979797"
        />
      </g>
      <defs>
        <clipPath id="clip0_2716_2719">
          <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
